<template>
  <v-app :class="getColourTheme">
    <dui-snackbar
      v-model="snackOpen"
      :color="snackColor"
      :message="snackMessage"
      :classSnack="snackClass"
      :styleSnack="snackStyle"
    />
    <app-toolbar
      class="app--toolbar"
      :items-language="itemsLanguage"
      @toggle-modal-logout-desktop="setToggleModalConfirmationLogout"
      @language-changed="
        ($event) => {
          itemsLanguage = $event;
        }
      "
    />
    <app-drawer :menu="myMenu" class="app--drawer" />
    <v-main>
      <nuxt class="page-wrapper" :nuxt-child-key="computedRouteViewKey" />
    </v-main>

    <!-- Confirmation Box (for delete) -->
    <dui-confirm
      ref="confirmation"
      :confirm-success-fn="$helpers.handleConfirmSuccess"
      :confirm-error-fn="$helpers.handleConfirmError"
    />

    <!-- Modal Confirmation Logout -->
    <modal-confirmation-logout-desktop
      v-model="modalConfirmationLogoutDesktop"
      :is-full-screen="false"
      @close="setToggleModalConfirmationLogout"
    />
  </v-app>
</template>

<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import ModalConfirmationLogoutDesktop from "@/components/page/Profile/ModalConfirmationLogoutDesktop";

// mixins
import mixinSnackbar from "@/mixins/Snackbar/mixinSnackbar";

import mixinAutomateLogout from "~/layouts/mixins/mixinAutomateLogout";
import mixinComputed from "~/layouts/mixins/mixinComputed";
import mixinCreated from "~/layouts/mixins/mixinCreated";
import mixinData from "~/layouts/mixins/mixinData";
import mixinMethods from "~/layouts/mixins/mixinMethods";
import mixinWatch from "~/layouts/mixins/mixinWatch";
import mixinWindowResize from "~/layouts/mixins/mixinWindowResize";

export default {
  // middleware: 'authenticated',
  name: "LayoutDefault",
  components: {
    AppDrawer,
    ModalConfirmationLogoutDesktop,
    AppToolbar,
  },
  mixins: [
    mixinData,
    mixinCreated,
    mixinComputed,
    mixinWatch,
    mixinMethods,
    mixinAutomateLogout,
    mixinWindowResize,
    mixinSnackbar,
  ],
  data() {
    return {
      modalConfirmationLogoutDesktop: false,
    };
  },
  methods: {
    setToggleModalConfirmationLogout() {
      this.modalConfirmationLogoutDesktop =
        !this.modalConfirmationLogoutDesktop;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  background-color: #f2f7ff;
  min-height: calc(100vh - 70px);
}

// fix policy/claim detail text color
::v-deep.v-application {
  &.black-and-white {
    #appDrawer .drawer-menu--scroll .v-list.v-list--dense {
      .v-list-item--active,
      .v-list-item:hover {
        .v-list-item__content .v-list-item__title {
          color: var(--bg) !important;
          font-weight: bold;
        }
        .v-icon {
          color: var(--bg) !important;
        }
      }
      .v-list-group.v-list-group--active {
        .v-list-group__header.v-list-item--active {
          .v-list-item:hover {
            .v-list-item__content .v-list-item__title {
              color: var(--bg) !important;
              font-weight: bold;
            }
            .v-icon {
              color: var(--bg) !important;
            }
          }

          .v-list-item__action .v-icon {
            color: var(--bg-secondary) !important;
          }
          .v-list-item__content .v-list-item__title {
            color: var(--bg-secondary) !important;
            caret-color: var(--bg-secondary) !important;
          }
          .v-icon {
            color: var(--bg-secondary) !important;
          }
        }
        .v-list-group__header.v-list-item--active + .v-list-group__items {
          .v-list-item--active {
            .v-list-item__action .v-icon {
              color: var(--bg) !important;
            }
            .v-list-item__content .v-list-item__title {
              color: var(--bg) !important;
              caret-color: var(--bg) !important;
            }
            .v-icon {
              color: var(--bg) !important;
            }
          }
        }
      }
    }
  }
}
</style>
